import {Order, OrderTokenType} from './Order';
import { jwtDecode } from 'jwt-decode';

class OrderInterpreter {
  public static InterpretFromToken(token:string): Order {
    var order = new Order();
    order.token = token;

    OrderInterpreter.ParseNestedTokens(token, order.types, order.messages);

    return order;
  }

  public static Empty(): Order {
    var order = new Order();
    order.token = '';
    order.types = [OrderTokenType.None];
    order.messages = [];

    return order;
  }

  private static ParseNestedTokens(token:string, tokens:Array<OrderTokenType>, messages:Array<any>): void {
    const decodedToken = OrderInterpreter.DecodeJwt(token);

    if(decodedToken?.tokens?.[0]?.token) {
        tokens.push(OrderInterpreter.ParseTokenTypes(decodedToken.type));
        if(decodedToken?.data?.messages) {
          messages.push(...decodedToken.data.messages);
        }

        OrderInterpreter.ParseNestedTokens(decodedToken.tokens[0].token, tokens, messages);
    }
  }

  private static DecodeJwt(token:string): any {
    return jwtDecode(token);
  }

  private static ParseTokenTypes(type:string): OrderTokenType {
    switch(type) {
      case "TruckDriverAssignment":
        return OrderTokenType.TruckDriverAssignment;
      case "LoadingStartTime":
        return OrderTokenType.LoadingStartTime;
      case "RequestEndLoadingConfirmation":
        return OrderTokenType.RequestEndLoadingConfirmation;
      case "LoadingEndTimeConfirmation":
        return OrderTokenType.LoadingEndTimeConfirmation;
    }

    return OrderTokenType.None;
  }
}

export default OrderInterpreter;